import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function Login() {
  const navigate = useNavigate()
  const { signUp, signIn, loading, resetPassword } = useAuth()
  const [isSignup, setIsSignup] = useState(false)
  const [resetMode, setResetMode] = useState(false)
  const [resetEmail, setResetEmail] = useState('')
  const [resetSent, setResetSent] = useState(false)
  const [form, setForm] = useState({ name: '', email: '', password: '' })
  const [rememberMe, setRememberMe] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    try {
      if (isSignup) {
        if (!form.name || !form.email || !form.password) {
          setError('Udfyld alle felter')
          return
        }
        await signUp(form.email, form.password, form.name)
      } else {
        if (!form.email || !form.password) {
          setError('Udfyld email og adgangskode')
          return
        }
        await signIn(form.email, form.password, rememberMe)
      }
      navigate('/dashboard')
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') setError('Email bruges allerede')
      else if (err.code === 'auth/invalid-email') setError('Ugyldig email')
      else if (err.code === 'auth/weak-password') setError('Adgangskode skal være mindst 6 tegn')
      else if (err.code === 'auth/user-not-found') setError('Bruger ikke fundet')
      else if (err.code === 'auth/wrong-password') setError('Forkert adgangskode')
      else setError(err.message || 'Der skete en fejl')
    }
  }

  const handleResetPassword = async (e) => {
    e.preventDefault()
    setError('')
    if (!resetEmail) {
      setError('Skriv din email')
      return
    }
    try {
      await resetPassword(resetEmail)
      setResetSent(true)
    } catch (err) {
      if (err.code === 'auth/user-not-found') setError('Bruger ikke fundet')
      else if (err.code === 'auth/invalid-email') setError('Ugyldig email')
      else setError(err.message || 'Der skete en fejl')
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f3f1e8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 360 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 80 }}>
          <div style={{ fontSize: 45, fontWeight: 700, color: '#1a1a2e', letterSpacing: -0.5 }}>
            Planora
          </div>
          <p style={{ fontSize: 13, color: '#DF83A9', fontFamily: 'inherit' }}>Planlæg dine events sammen</p>
        </div>

        <div className="card" style={{ boxShadow: '0 8px 32px rgba(108,99,255,0.1)' }}>
          {resetMode && !resetSent ? (
            <>
              <h2 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>Nulstil Adgangskode</h2>
              <p style={{ fontSize: 12, color: '#DF83A9', marginBottom: 20 }}>Skriv Din Email, Og Vi Sender Dig Et Link</p>
              {error && <div style={{ background: '#ffe4e4', color: '#cc2020', padding: '10px 12px', borderRadius: 8, fontSize: 12, marginBottom: 12 }}>{error}</div>}
              <form onSubmit={handleResetPassword} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="input-label">Email</label>
                  <input className="input" type="email" placeholder="din@email.dk" value={resetEmail} onChange={e => setResetEmail(e.target.value)} disabled={loading} />
                </div>
                <button type="submit" disabled={loading} className="btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '11px 0', marginTop: 4, opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}>
                  {loading ? 'Sender...' : 'Send Nulstillings-Link'}
                </button>
              </form>
              <p style={{ textAlign: 'center', fontSize: 12, color: '#DF83A9', marginTop: 14 }}>
                <span style={{ color: '#6c63ff', cursor: 'pointer', fontWeight: 500 }} onClick={() => { setResetMode(false); setError(''); }}>← Tilbage Til Log Ind</span>
              </p>
            </>
          ) : resetSent ? (
            <>
              <h2 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>Tjek Din Email</h2>
              <p style={{ fontSize: 12, color: '#DF83A9', marginBottom: 20 }}>Vi Har Sendt Et Nulstillings-Link Til {resetEmail}</p>
              <div style={{ background: '#e8fdf5', border: '1px solid #06d6a0', borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: '#007a58' }}>
                ✓ Følg linket i emailen for at nulstille din adgangskode
              </div>
              <button onClick={() => { setResetMode(false); setResetSent(false); setResetEmail(''); setError(''); }} className="btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '11px 0' }}>
                tilbage til log ind
              </button>
            </>
          ) : (
            <>
              <p style={{ fontSize: 18, fontWeight: 700, color: '#222222', marginBottom: 20, textAlign: 'center' }}>
                {isSignup ? 'Opret Profil' : 'Log Ind'}
              </p>
              <h2 style={{ fontSize: 12, fontWeight: 400, color: '#3c3c3c', marginBottom: 20, textAlign: 'center'  }}>
                {isSignup ? 'Et par detaljer og så er du igang' : 'Velkommen Tilbage'}
              </h2>

              {error && <div style={{ background: '#ffe4e4', color: '#cc2020', padding: '10px 12px', borderRadius: 8, fontSize: 12, marginBottom: 12 }}>{error}</div>}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {isSignup && (
                  <div className="input-group" style={{ marginBottom: 0 }}>
                    <label className="input-label">Dit navn</label>
                    <input className="input" placeholder="fornavn efternavn" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} disabled={loading} />
                  </div>
                )}
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="input-label">E-mail</label>
                  <input className="input" type="email" placeholder="din@email.dk" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} disabled={loading} />
                </div>
                <div className="input-group" style={{ marginBottom: 0 }}>
                  <label className="input-label">Vælg adgangskode</label>
                  <input className="input" type="password" placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} disabled={loading} />
                </div>
                {!isSignup && (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: 8 }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 12, color: '#1a1a2e', fontWeight: 500 }}>
                        <input
                          type="checkbox"
                          checked={rememberMe}
                          onChange={e => setRememberMe(e.target.checked)}
                          disabled={loading}
                          style={{ width: 16, height: 16, cursor: 'pointer' }}
                        />
                        Husk mig
                      </label>
                      <span onClick={() => { setResetMode(true); setError(''); }} style={{ fontSize: 11, color: '#6c63ff', cursor: 'pointer', fontWeight: 500 }}>glemt adgangskode?</span>
                    </div>
                  </>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  className="btn-primary"
                  style={{ width: '100%', justifyContent: 'center', padding: '11px 0', marginTop: 4, opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                >
                  {loading ? 'henter...' : (isSignup ? 'Opret profil' : 'Log ind')}
                </button>
              </form>

              <p style={{ textAlign: 'center', fontSize: 12, color: '#969696', marginTop: 14 }}>
                {isSignup ? 'Har du allerede en konto? ' : 'Ingen konto? '}
                <span style={{ color: '#6c63ff', cursor: 'pointer', fontWeight: 500 }} onClick={() => setIsSignup(!isSignup)}>
                  {isSignup ? 'Log ind' : 'Opret profil'}
                </span>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
